import React from 'react';
import ReactDOMServer from 'react-dom/server';

// Dependencies
import jsxToString from 'jsx-to-string';

// Components
import Dialog from '../../../common/Dialog';
import Snippet from '../../../common/Snippet';

const content = {
  body: 'Are you sure you want to delete this data?',
  button: 'Delete',
  cancel: 'Cancel',
  heading: 'Dialog title'
}

const Confirmation = class Confirmation extends React.Component {
  example = (
    <Dialog
      content={content}
      onCancel={() => console.log('Dialog cancelled.')}
      onConfirm={() => console.log('Dialog confirmed.')}
      type="confirm"
    />
  );

  render() {
    const { translation } = this.props;

    return (
      <section className="page__section">
        <h3>{translation.examples.confirmation}</h3>

        <article className="example">{this.example}</article>

        {/* TODO: Look at this instead of jsxToString (https://github.com/algolia/react-element-to-jsx-string) */}

        <Snippet
          {...this.props}
          code={ReactDOMServer.renderToStaticMarkup(this.example)}
          name="primary"
          react={jsxToString(this.example)}
        />
      </section>
    );
  }
};

export default Confirmation;
